import { render } from "./TreatmentHistory.vue?vue&type=template&id=7708c3f8&class=main-events-timeline"
import script from "./TreatmentHistory.vue?vue&type=script&lang=js"
export * from "./TreatmentHistory.vue?vue&type=script&lang=js"

import "./TreatmentHistory.vue?vue&type=style&index=0&id=7708c3f8&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__